module.exports = {"url":"https://my.festzelt-os.com/#!/","studioBackendUrl":"","apiUrl":"https://api.festzelt-os.com/api","pusher":{"key":"glcvllcijgkbdpsq","cluster":"eu","encrypted":true,"host":"main.sockets.airlst.com"},"rollbarKey":"f3a891bfc83f459f852c41c65e86e88a","rollbarEnv":"production","rollbarLvl":"error","name":"local","html5":"false","version":"4.8.1","currentYear":2022}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = 105
// module chunks = 1